// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sIcHl","rootMobile":"styles_rootMobile__2Ny_1"};